import { compose } from "redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import { withStyles, Paper } from "@material-ui/core";

class SidePanel extends PureComponent {
  render() {
    const { classes, children } = this.props;

    return (
      <Grid
        item
        square
        elevation={8}
        component={Paper}
        className={classes.root}
      >
        <Grid xs item container spacing={2} className={classes.subRoot}>
          <Grid container className={classes.rootContent}>
            <Grid container className={classes.subRootContent}>
              {children}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    zIndex: 3,
  },
  subRoot: {
    margin: 0,
    width: 320,
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    background: "transparent",
  },
  rootContent: {
    height: "100%",
  },
  subRootContent: {
    padding: `${theme.spacing(2)}px ${theme.spacing(1.5)}px`,
  },
});

export default compose(withStyles(styles))(SidePanel);
